import React from "react";

const Header = ({ title, lead, cta_text, cta_link }) => {
    return (
        <header className="header-section">
            {/* <div className="overlay-dark"></div> */}
            <div className="container position-relative my-5">
                <div className="row align-items-lg-center">
                    <div className="col-lg-10 col-xl-8">
                        <h1>{title}</h1>
                        <p className="lead">{lead}</p>
                        {cta_text && cta_link && (
                            <a href={cta_link} className="btn btn-primary mt-3" title="" aria-label="">
                                {cta_text}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
